/**
 * press-carousel.js — 头条媒体舞台自动轮播。
 *
 * 行为:第一项为视频(进页面自动播放、静音);视频 ended → 自动切到图片,
 *      每张停留 IMG_DUR 后切下一张,循环回视频重播。缩略图可手动切换。
 *      点击视频 → 居中放大灯箱(带控件,可放声)。仅在进视口时播放/轮播,
 *      离开暂停;reduced-motion 不自动播放/轮播,仅保留缩略图手动切换。
 *
 * 标记:[data-press-carousel] 根 · [data-carousel-stage] 舞台 · [data-carousel-item]
 *      (data-type=video|image)· [data-carousel-thumb=i] 缩略 · [data-carousel-zoom] ·
 *      [data-carousel-lightbox] / [data-carousel-lightbox-video] / [data-carousel-lightbox-close]
 */
(function () {
  var IMG_DUR = 4500;

  function initCarousel(root) {
    if (root.dataset.carouselReady === '1') return;
    root.dataset.carouselReady = '1';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-item]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-thumb]'));
    var stage = root.querySelector('[data-carousel-stage]');
    var video = root.querySelector('video[data-carousel-item]');
    var zoom = root.querySelector('[data-carousel-zoom]');
    if (!items.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var section = root.closest('section') || document;
    var lb = section.querySelector('[data-carousel-lightbox]');
    var lbVideo = lb && lb.querySelector('[data-carousel-lightbox-video]');
    var idx = 0, timer = null, inView = false;

    function clearT() { if (timer) { clearTimeout(timer); timer = null; } }
    function isVideo(i) { return items[i] && items[i].dataset.type === 'video'; }

    function show(i) {
      idx = (i + items.length) % items.length;
      items.forEach(function (el, k) { el.classList.toggle('is-active', k === idx); });
      thumbs.forEach(function (t, k) {
        var on = k === idx;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (stage) stage.classList.toggle('is-video', isVideo(idx));
      clearT();
      if (isVideo(idx) && video) {
        try { video.currentTime = 0; } catch (e) {}
        if (!reduce) {
          var p = video.play();
          if (p && p.catch) p.catch(function () { if (inView) timer = setTimeout(nextItem, IMG_DUR); });
        }
      } else {
        if (video) video.pause();
        if (!reduce && inView) timer = setTimeout(nextItem, IMG_DUR);
      }
    }
    function nextItem() { show(idx + 1); }

    if (video) {
      video.addEventListener('ended', function () { if (isVideo(idx)) nextItem(); });
      video.addEventListener('click', openLB);
      if (zoom) zoom.addEventListener('click', openLB);
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });

    function openLB() {
      if (!lb) return;
      clearT();
      if (video) video.pause();
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (lbVideo) {
        try { lbVideo.currentTime = video ? video.currentTime : 0; } catch (e) {}
        var p = lbVideo.play(); if (p && p.catch) p.catch(function () {});
      }
    }
    function closeLB() {
      if (!lb) return;
      lb.hidden = true;
      document.documentElement.style.overflow = '';
      if (lbVideo) lbVideo.pause();
      if (inView) show(idx);
    }
    if (lb) {
      lb.querySelectorAll('[data-carousel-lightbox-close]').forEach(function (el) { el.addEventListener('click', closeLB); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) closeLB(); });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          inView = e.isIntersecting;
          if (inView) { if (lb && !lb.hidden) return; show(idx); }
          else { clearT(); if (video) video.pause(); }
        });
      }, { threshold: 0.3 });
      io.observe(stage || root);
    } else {
      inView = true;
      show(0);
    }
  }

  function init() { document.querySelectorAll('[data-press-carousel]').forEach(initCarousel); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
